import { PageLayout } from "../components/PageLayout";
import { useDocumentMeta } from "../lib/router";

export function TermsPage() {
  useDocumentMeta({
    title: "利用規約 | 食べログ ラーメン百名店マップ",
    description:
      "食べログ ラーメン百名店マップの利用規約です。本サイトを利用することでユーザーは本規約に同意したものとみなされます。",
  });

  return (
    <PageLayout title="利用規約" lastUpdated="2026-04-13">
      <p>
        本利用規約 (以下「本規約」といいます) は、食べログ ラーメン百名店マップ
        (以下「本サイト」といいます) の利用条件を定めるものです。ユーザーは
        本サイトを利用することで本規約に同意したものとみなされます。
      </p>

      <h2>1. 本サイトの目的</h2>
      <p>
        本サイトは、食べログ「ラーメン百名店」の歴代選出店舗を地図上で
        可視化し、ユーザーが店舗情報を探しやすくすることを目的とした
        非公式かつ非営利の情報提供サイトです。
      </p>

      <h2>2. 第三者との関係</h2>
      <p>
        本サイトは食べログ株式会社、株式会社カカクコム、および Google LLC
        等の第三者とは一切関係がありません。「食べログ」「ラーメン百名店」
        等の名称・商標は各権利者に帰属します。
      </p>

      <h2>3. 著作権および知的財産権</h2>
      <p>
        本サイトに掲載されている店舗情報 (店名、選出年、選出カテゴリ等) の
        権利は食べログ株式会社に帰属します。座標・住所・写真・評価・
        営業時間等の情報は Google Maps Platform から取得したもので、これらの
        権利は Google LLC または各権利者に帰属します。
      </p>
      <p>
        本サイトのソースコードおよび独自に作成した UI 要素・ドキュメントの
        著作権は本サイト運営者に帰属します。
      </p>

      <h2>4. 禁止事項</h2>
      <p>ユーザーは、本サイトの利用にあたり以下の行為を行ってはなりません。</p>
      <ul>
        <li>法令または公序良俗に違反する行為</li>
        <li>犯罪行為に関連する行為</li>
        <li>本サイトの運営を妨害するおそれのある行為</li>
        <li>本サイトを逆コンパイル・解析してデータを抽出する行為</li>
        <li>本サイトに過度な負荷をかける自動アクセス (クローリング等)</li>
        <li>本サイトの API を運営者の許可なく第三者サービスに組み込む行為</li>
        <li>
          本サイトから取得した Google Maps Platform 由来のデータを Google の
          利用規約に違反する形で使用する行為
        </li>
      </ul>

      <h2>5. 本サイトの提供の停止等</h2>
      <p>
        運営者は、以下のいずれかの事由があると判断した場合、ユーザーに
        事前に通知することなく、本サイトの全部または一部の提供を停止または
        中断することができるものとします。
      </p>
      <ul>
        <li>本サイトにかかるシステムの保守点検または更新を行う場合</li>
        <li>
          地震、落雷、火災、停電または天災等の不可抗力により、本サイトの
          提供が困難となった場合
        </li>
        <li>コンピュータまたは通信回線等が事故により停止した場合</li>
        <li>Google Maps Platform 等の依存サービスに障害が発生した場合</li>
        <li>その他、運営者が本サイトの提供が困難と判断した場合</li>
      </ul>

      <h2>6. 免責事項</h2>
      <p>
        本サイトに掲載されている情報の正確性、最新性、完全性について、
        運営者は一切の保証を行いません。詳細は免責事項のページをご確認ください。
      </p>

      <h2>7. 規約の変更</h2>
      <p>
        運営者は、必要と判断した場合には、ユーザーに通知することなく
        いつでも本規約を変更することができるものとします。
      </p>

      <h2>8. 準拠法・裁判管轄</h2>
      <p>
        本規約の解釈にあたっては日本法を準拠法とします。本サイトに関して
        紛争が生じた場合、運営者の所在地を管轄する裁判所を専属的合意管轄と
        します。
      </p>
    </PageLayout>
  );
}
